import { USERUUID, IUSERDATA, IssuerData, GitInfo } from '../utils/types';

const { REACT_APP_SERVER_URL, REACT_APP_BACKEND_URL } = process.env;

// export const server = "http://54.205.0.251:5000";
// flip comments if testing locally
// export const server = REACT_APP_SERVER_URL;
// export const server = "http://localhost:3000";
// export const dashboardServer = "https://bolt-lending.com";

export const server: string = REACT_APP_SERVER_URL as string;
export const endpoint = REACT_APP_BACKEND_URL;

console.log(`endpoint will be: ${endpoint}`);
//Dashboard url for symlink from dashboard repo
//export const dashboardURL = `${dashboardServer}/api/bolt/transactions`;

// Authentication
export const loginURL = `/login`;
export const logoutURL = `/logout`;

// User APIs
export const registerURL = `/user`;
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const userBoltURL = (merchantID?: USERUUID) => {
  const url = `/user/my-bolts`;
  if (merchantID) {
    return url + '?merchantId=' + merchantID;
  }
  return url;
};
export const issuersURL = `/user/list/issuers`;
export const userURL = `/user/profile`;
export const delegateURL = `/user/delegate`;
export const forgotPasswordURL = `/user/forgot-password`;
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const resetPasswordURL = (username: string) =>
  `/user/reset-password/${username.toLowerCase()}`;
export const changePasswordURL = `/user/change-password`;
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const searchUserByIdURL = (userId: string) => {
  const result = `/user/${userId}`;
  return result;
};

// Transaction APIs
export const txnBoltURL = `/v2/transaction`;
export const txnSqlURL = `/v2/transaction/fromsqr`;
export const acceptAndRejectTxn = `/v2/transaction/`;
// export const userTxnsURL = (merchantID?: USERUUID) => {
//   const url = `/transaction/user-txns`;
//   if (merchantID) {
//     return url + "?merchantId=" + merchantID;
//   }
//   return url;
// };

// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const userTxnsURLV2 = (merchantID?: USERUUID) => {
  const url = `/v2/transaction/user-txns`;
  if (merchantID) {
    return url + '?merchantId=' + merchantID;
  }
  return url;
};
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const buybackURL = (user: USERUUID) => `/transaction/buyback/${user}`;

// Bolt APIs
export const createBoltURL = `/bolt`;
export const mintBoltURL = `/bolt/mint`;
export const sellBoltURL = `/stripe/sell`;
export const getBoltURL = `/v2/bolt/`;
export const donateBoltURL = `/user/donate/`;
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getBoltsByIDsURL = (specIDs: string[]) => {
  const url = `/v2/bolt`;
  if (specIDs) {
    return url + '?specIDs=' + specIDs;
  }
  return url;
};
export const requestZuzCreateURL = '/bolt/reqauth';
// Other
// FIXLATER
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getImageURL = (imagePath: string) =>
  `${REACT_APP_SERVER_URL}/${imagePath}`;
export const searchIssuersURL = `/v2/user/list/issuers/`;
export const campaignURL = `/bolt/campaign/`;
export const checkTokenURL = `/user/check-token`;

export interface ApiErrorResponse {
  status: 'error';
  msg: string;
}

export interface ApiResponse {
  status: 'success';
}

export const backendGitURL = `/general`;

export interface GitResponse extends ApiResponse {
  data: GitInfo;
}

export const issuerURL = `/user/issuer/`;

export interface IssuerResponse extends ApiResponse {
  issuer: IssuerData;
}

export const searchUsersURL = (query: string): string => {
  const result = `/user/search?query=${query}`;
  return result;
};

export interface SearchResponse extends ApiResponse {
  data: {
    users: IUSERDATA[];
  };
}

export const checkUsernameURL = `/user/check-username/`;

export interface CheckUserResponse extends ApiResponse {
  username: {
    available: boolean;
  };
}

export class APIError extends Error {
  constructor(response: ApiErrorResponse) {
    super(response.msg);
    this.name = 'APIError';
  }
}
